import { render, staticRenderFns } from "./StripeTransactionDetailsV2.vue?vue&type=template&id=ce937b74&scoped=true&"
import script from "./StripeTransactionDetailsV2.vue?vue&type=script&lang=js&"
export * from "./StripeTransactionDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./StripeTransactionDetailsV2.vue?vue&type=style&index=0&id=ce937b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce937b74",
  null
  
)

export default component.exports